import PageHeader from '../components/molecules/PageHeader';
import useUpdateSacrament from '../hooks/updateSacrament.hook';
import { ToastContainer } from 'react-toastify';

const UpdateSacrament = () => {
  // generate levels 1 - 10
  const levelOptions = [];
  for (let i = 1; i <= 10; i++) {
    levelOptions.push(i);
  }

  // call hook
  const {
    data,
    studentArray,
    handleLevelChange,
    removeStudent,
    saveForm,
    sacramentDetails,
    setSacramentDetails,
  } = useUpdateSacrament();

  // for generating separator between session time
  let session_diff = '1';
  let showSeparator = false;

  // output
  return (
    <div>
      <PageHeader>Update Sacraments</PageHeader>
      <ToastContainer />

      <div className='grid grid-cols-2 gap-x-6 gap-y-8'>
        <div>
          <label className='block font-medium' htmlFor='sacramentType'>
            Sacrament Type
          </label>
          <select
            name='sacramentType'
            id='sacramentType'
            className='my-3 block rounded-md border py-1.5 '
            onChange={e =>
              setSacramentDetails({
                ...sacramentDetails,
                type: e.target.value,
              })
            }
          >
            <option value='fr'>First Recon</option>
            <option value='hc'>Holy Communion</option>
          </select>
        </div>

        {/* Date */}
        <div>
          <label htmlFor='sacramentDate' className='block font-medium'>
            Date
          </label>
          <input
            type='date'
            className='my-4 rounded-md border p-3'
            value={sacramentDetails?.date}
            onChange={e =>
              setSacramentDetails({
                ...sacramentDetails,
                date: e.target.value,
              })
            }
          ></input>
        </div>

        <div className='col-span-2'>
          <label htmlFor='level' className='block'>
            Select a Level
          </label>
          {/* Level dropdown */}
          <select
            name='level'
            id='level'
            className='my-3 block rounded-md border py-1.5 '
            onChange={handleLevelChange}
          >
            <option value=''>&nbsp;</option>
            {levelOptions.map(level => (
              <option key={level} value={level}>
                Level {level}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className='spacer'></div>

      <div className='block'>
        {/* Process student array */}
        {studentArray?.map(student => {
          if (session_diff !== student.student_session_time) {
            showSeparator = true;
            session_diff = student.student_session_time;
          } else {
            showSeparator = false;
          }

          return (
            <div
              key={student.student_id}
              onClick={() => removeStudent(student.student_id)}
              className='cursor-pointer transition hover:text-gray-400'
            >
              {showSeparator ? (
                <div className='spacer'>&nbsp;</div>
              ) : (
                <div></div>
              )}
              {student.student_first_name} {student.student_last_name}
            </div>
          );
        })}
      </div>

      <div className='spacer'></div>

      {studentArray.length ? (
        <button
          className='btn btn-primary rounded-md bg-primary-800 p-5 font-bold text-white duration-300 hover:bg-secondary-800'
          onClick={saveForm}
        >
          Update and Save
        </button>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default UpdateSacrament;
